import { createSlice } from "@reduxjs/toolkit";
import { getMemberPlans, getPlans } from "./_planAction";

const initialState: any = {
  data: [],
  plans: [],
  isLoading: true,
  isSuccess: false,
  responseCode: null,
  responseMessage: '',
  totalRecord: 0,
};

export const planList = createSlice({
  name: "planList",
  initialState: initialState,
  reducers: {},
  extraReducers(builder) {
    builder
      .addCase(getPlans.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getPlans.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.data = payload.data||[];
        state.responseMessage = payload.responseMessage
        state.responseCode = payload.responseCode
        state.totalRecord = payload.totalRecord || 0
      })
      .addCase(getPlans.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
      .addCase(getMemberPlans.pending, (state) => {
        state.isLoading = true;
        state.isSuccess = false;
      })
      .addCase(getMemberPlans.fulfilled, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = true;
        state.plans = payload.data||[];
        state.responseMessage = payload.responseMessage
        state.responseCode = payload.responseCode
        state.totalRecord = payload.totalRecord || 0
      })
      .addCase(getMemberPlans.rejected, (state, { payload }) => {
        state.isLoading = false;
        state.isSuccess = false;
        state.errorMessage = payload;
      })
  },
});
